import styled from "styled-components";
import {
    PC_HORIZONTAL_SPACE_BETWEEN_ITEMS
} from "../../../../../../../../../../basic-components/space-between-items-consts";


export const AmountLabelBox = styled.div`
    margin-right: ${PC_HORIZONTAL_SPACE_BETWEEN_ITEMS()};
`